import { useTranslation } from 'react-i18next';
import { Heading, LiliTextInput } from '@lili/lili-frontend-common';
import { ControllerWrapper } from '@Hooks/index';
import { EddEmbeddedFields } from '@Pages/happyFlowPages/eddQuestions/pages/embedded/fields.types';

export const NonprofitSocialMediaForm = () => {
  const { t } = useTranslation('eddQuestions');

  return (
    <div className='flex flex-col mt-[16px]'>
      <div className='flex flex-col gap-2'>
        <Heading.H9>{t('organic.NonProfitSocialMedia.websiteQuestion')}</Heading.H9>
        <ControllerWrapper name={EddEmbeddedFields.EDD_NONPROFIT_WEBSITE}>
          {({ onChange, value, error, onBlur }) => (
            <LiliTextInput
              value={value}
              onChange={onChange}
              errorMessage={error?.message}
              title={t('organic.NonProfitSocialMedia.websitePlaceholder')}
              onBlur={onBlur}
              id={EddEmbeddedFields.EDD_NONPROFIT_WEBSITE}
              isPublic
            />
          )}
        </ControllerWrapper>
      </div>
    </div>
  );
};
